export const SESSION_AUTH_STATE_KEY = 'sessionAuth';
